import React, { useState, useCallback } from "react";

import Member1 from "../assets/images/11.jpg";
import Member2 from "../assets/images/12.jpg";
import Member3 from "../assets/images/13.jpg";
import Member4 from "../assets/images/14.jpg";
import Member5 from "../assets/images/16.jpg";
import Member6 from "../assets/images/21.jpg";
import Carousel, { Modal, ModalGateway } from "react-images";

function Standard() {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };
  const standardCards = [
  
    {
      src: "/assets/images/11.png",
      // width: 5,
      // height: 5,
    },
    {
      src: "/assets/images/16.png",
      // width: 5,
      // height: 5,
    },
    {
      src: "/assets/images/21.png",
      // width: 5,
      // height: 5,
    },
  ];
  return (
    <div className="Standard" id="gallery">
      <div className="container">
        <div className="standardInfo mb-5 text-center">
          <h1 className="sectionHeading" data-aos="fade-down">
            A RICHER <span>AND HIGHER</span> STANDARDS{" "}
            <span>FOR GENERATIVE</span> NFTS
          </h1>
          <h6>
          Owning a Sol Survivor we will get rid of the hassle of WL grinding, every day we will have whitelist spots from up and coming NFT projects ready for you without having to spend days and days grinding. We will build a fierce army of alpha callers and together we will take our bags to the next level! 
          </h6>
         
        </div>
        <div className="row g-0">
          {/* <Gallery photos={standardCards} onClick={openLightbox} /> */}
          <ModalGateway>
            {viewerIsOpen ? (
              <Modal onClose={closeLightbox}>
                <Carousel
                  currentIndex={currentImage}
                  views={standardCards.map((x) => ({
                    ...x,
                    srcset: x.srcSet,
                    caption: x.title,
                  }))}
                />
              </Modal>
            ) : null}
          </ModalGateway>
          {standardCards.map((item, i) => (
            <div className="col-md-4 col-6">
              <div className="standardImg " onClick={() => openLightbox(i)}>
                <img className="img-fluid" src={item.src} alt="click here" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
} 

export default Standard;
